import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, unref as _unref, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-12ea40d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "annotations",
  ref: "annotationsDiv"
}
const _hoisted_2 = { class: "connection-lines" }

import {PropType, Ref} from "vue";
import DotAnnotation from "@/components/frame/image/annotation/DotAnnotation.vue";
import {SSpatial2DDotAnnotation} from "@/store/Spatial2DAnnotation/model/SSpatial2DDotAnnotation";
import {SSpatial2DBoundingBox} from "@/store/Spatial2DAnnotation/model/SSpatial2DBoundingBox";
import {defaultAnnotatableBodyPartsDisplayParams} from "@/data/annotation/DefaultAnnotatableBodyPartsDisplayParams";
import ConnectionLine from "@/components/frame/image/annotation/ConnectionLine.vue";

// ------------------------------
//  Base
// ------------------------------


export default /*#__PURE__*/_defineComponent({
  name: 'DotAnnotations',
  props: {
  dotAnnotations: {
    type: Array as PropType<SSpatial2DDotAnnotation[]>,
    required: true,
  },
  parentBoundingBox: {
    type: Object as PropType<SSpatial2DBoundingBox>,
    required: true,
  },
  parentOverlayRef: {
    type: Object as PropType<Ref<HTMLElement>>,
    required: true,
  },
  forceConnectingLineRedraw: Number
},
  emits: ["onHoveredAnnotations"],
  setup(__props, { emit: emits }) {






// ------------------------------
//  Annotations hover handling
// ------------------------------

const hoveredAnnotations: SSpatial2DDotAnnotation[] = [];

const onDotAnnotationMouseOver = (annotation: SSpatial2DDotAnnotation) => {
  if (!hoveredAnnotations.filter(hoveredAnnotation => hoveredAnnotation.instanceId === annotation.instanceId).length)
  {
    hoveredAnnotations.push(annotation);
    emits("onHoveredAnnotations", hoveredAnnotations)
  }
}

const onDotAnnotationMouseLeave = (annotation: SSpatial2DDotAnnotation) =>
{
  if (hoveredAnnotations.filter(hoveredAnnotation => hoveredAnnotation.instanceId === annotation.instanceId).length)
  {
    hoveredAnnotations.splice(hoveredAnnotations.findIndex(hoveredAnnotation => hoveredAnnotation.instanceId === annotation.instanceId), 1)
    emits("onHoveredAnnotations", hoveredAnnotations)
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.dotAnnotations, (dotAnnotation) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "dot-annotations-container",
        key: dotAnnotation.instanceId
      }, [
        _createVNode(DotAnnotation, {
          "dot-annotation": dotAnnotation,
          "parent-overlay-ref": __props.parentOverlayRef,
          "parent-bounding-box": __props.parentBoundingBox,
          onOnTrueMouseover: onDotAnnotationMouseOver,
          onOnTrueMouseleave: onDotAnnotationMouseLeave
        }, null, 8, ["dot-annotation", "parent-overlay-ref", "parent-bounding-box"])
      ]))
    }), 128)),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(defaultAnnotatableBodyPartsDisplayParams), (bodyPartParams) => {
        return (_openBlock(), _createElementBlock("div", {
          key: bodyPartParams.value,
          class: "connecting-lines-group"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bodyPartParams.connectionLines, (connectionLine, index) => {
            return (_openBlock(), _createBlock(ConnectionLine, {
              key: index,
              color: connectionLine.colorCode,
              "from-element-id": 'dot-annotation-' + __props.parentBoundingBox.instanceId + '-' + bodyPartParams.value,
              "to-element-id": 'dot-annotation-' + __props.parentBoundingBox.instanceId + '-' + connectionLine.connectedWith,
              "force-redraw": __props.forceConnectingLineRedraw
            }, null, 8, ["color", "from-element-id", "to-element-id", "force-redraw"]))
          }), 128))
        ]))
      }), 128))
    ])
  ], 512))
}
}

})